import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import MenuIcon from "@mui/icons-material/Menu";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import logocrop from "../../../assets/images/logo-crop-removebg.png";

const navItems = [
  { label: "Home", view: "home" },
  { label: "About", view: "about" },
  { label: "Contact", view: "contact" },
  { label: "Policies", view: "policyPage" },
];

function AppAppBar({ setView }) {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (view) => () => {
    setView(view);
    setOpen(false);
  };

  return (
    <AppBar
      position="fixed"
      elevation={scrolled ? 3 : 0}
      sx={{
        bgcolor: scrolled
          ? "rgba(255,255,255,0.97)"
          : "rgba(10, 30, 60, 0.72)",
        backdropFilter: "blur(12px)",
        transition: "all 0.35s ease",
        borderBottom: scrolled
          ? "1px solid rgba(0,0,0,0.07)"
          : "1px solid rgba(255,255,255,0.08)",
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ py: 1, minHeight: 68 }}>
          {/* Brand */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={1.2}
            onClick={handleNav("home")}
            sx={{ cursor: "pointer", mr: 4 }}
          >
            <Box
              component="img"
              src={logocrop}
              alt="logo"
              sx={{ width: 44, height: 44, objectFit: "contain",
              filter: scrolled ? "none" : "brightness(0) invert(1)",
              transition: "filter 0.35s ease",
            }}
            />
            <Box>
              <Typography
                variant="subtitle1"
                fontWeight={800}
                sx={{
                  lineHeight: 1.1,
                  color: scrolled ? "#1565C0" : "white",
                  letterSpacing: 1.5,
                  transition: "color 0.3s",
                }}
              >
                VISHMITHA
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: scrolled ? "#546E7A" : "rgba(255,255,255,0.75)",
                  letterSpacing: 0.8,
                  transition: "color 0.3s",
                }}
              >
                HIGHWAY EXPRESS
              </Typography>
            </Box>
          </Stack>

          {/* Desktop nav links */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              gap: 0.5,
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.view}
                onClick={handleNav(item.view)}
                sx={{
                  px: 2,
                  py: 1,
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  color: scrolled ? "#334155" : "rgba(255,255,255,0.9)",
                  borderRadius: 2,
                  transition: "all 0.2s",
                  "&:hover": {
                    color: "#1565C0",
                    bgcolor: scrolled
                      ? "rgba(21,101,192,0.07)"
                      : "rgba(255,255,255,0.15)",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            <Button
              onClick={handleNav("about")}
              variant="contained"
              sx={{
                borderRadius: 8,
                px: 3,
                py: 1,
                fontWeight: 700,
                background: "linear-gradient(135deg, #1565C0 0%, #0288D1 100%)",
                boxShadow: "0 4px 18px rgba(21,101,192,0.4)",
                "&:hover": {
                  boxShadow: "0 6px 24px rgba(21,101,192,0.55)",
                  transform: "translateY(-1px)",
                },
                transition: "all 0.2s ease",
              }}
            >
              View Bus
            </Button>
          </Box>

          {/* Mobile hamburger */}
          <Box sx={{ display: { xs: "flex", md: "none" }, ml: "auto" }}>
            <Button
              onClick={() => setOpen(true)}
              sx={{
                minWidth: 0,
                p: 1,
                color: scrolled ? "#1565C0" : "white",
              }}
            >
              <MenuIcon />
            </Button>
            <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
              <Box sx={{ width: 270, p: 3 }}>
                <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
                  <DirectionsBusIcon color="primary" />
                  <Typography variant="h6" fontWeight={800} color="primary">
                    VISHMITHA
                  </Typography>
                </Stack>
                <Divider sx={{ mb: 2 }} />
                {navItems.map((item) => (
                  <MenuItem
                    key={item.view}
                    onClick={handleNav(item.view)}
                    sx={{ borderRadius: 2, mb: 0.5, fontWeight: 600 }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
                <Divider sx={{ my: 2 }} />
                <Button
                  onClick={handleNav("about")}
                  fullWidth
                  variant="contained"
                  sx={{
                    borderRadius: 8,
                    py: 1.2,
                    fontWeight: 700,
                    background:
                      "linear-gradient(135deg, #1565C0 0%, #0288D1 100%)",
                  }}
                >
                  View Bus
                </Button>
              </Box>
            </Drawer>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default AppAppBar;
